import React from 'react';

const NoMail = () => {
  return (
    <svg
      width='271'
      height='237'
      viewBox='0 0 271 237'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_5887_587740)'>
        <path
          d='M257.175 34.1931C250.745 25.3298 240.656 14.5587 227.523 13.5801C210.167 12.2848 201.84 29.1384 181.512 32.3768C171.844 33.9186 157.519 32.6936 138.422 18.9164'
          stroke='#00468A'
          stroke-width='0.5'
          stroke-miterlimit='10'
          stroke-dasharray='8 8'
        />
        <path
          d='M183.408 46.8086H116.973V132.689H213.929V79.9879C213.929 61.6629 200.265 46.8086 183.408 46.8086Z'
          fill='#00468A'
        />
        <path
          d='M118.773 46.8086C135.617 46.8086 149.294 61.677 149.294 79.9879V132.689H88.2461V79.9879C88.2461 61.677 101.923 46.8086 118.767 46.8086H118.773Z'
          fill='#42152A'
        />
        <path
          d='M121.538 46.9494C120.625 46.8579 119.706 46.8086 118.767 46.8086C101.91 46.8086 88.2461 61.6629 88.2461 79.9879V132.689H93.7829V79.9879C93.7829 62.6766 105.977 48.47 121.538 46.9494Z'
          fill='#00468A'
        />
        <path
          d='M171.882 132.689H159.027V236.571H171.882V132.689Z'
          fill='#1B224C'
        />
        <path
          d='M171.882 132.689H159.027V142.728H171.882V132.689Z'
          fill='#2E3A7F'
        />
        <path
          d='M167.09 13.918V42.7607L198.446 28.3358L167.09 13.918Z'
          fill='#F3223C'
        />
        <path
          d='M168.937 69.4772C167.9 69.4772 167.059 68.562 167.059 67.4356V20.106C167.059 18.9796 167.9 18.0645 168.937 18.0645C169.973 18.0645 170.815 18.9796 170.815 20.106V67.4356C170.815 68.562 169.973 69.4772 168.937 69.4772Z'
          fill='#F3223C'
        />
        <path
          d='M213.928 114.998H149.293V132.689H213.928V114.998Z'
          fill='#1088F3'
        />
        <path
          d='M213.928 102.023H149.293V109.936H213.928V102.023Z'
          fill='#1088F3'
        />
        <path
          d='M47.6826 88.76C47.961 86.0145 48.8871 84.6346 48.0711 83.2548C47.3847 82.0932 46.4781 81.8186 45.2282 80.7767C42.6314 78.6084 43.5445 77.13 41.4982 75.5742C40.0022 74.4408 39.2575 75.2926 35.3591 75.3348C30.826 75.3841 30.9685 73.5819 28.0479 74.49C25.613 75.2504 23.2558 77.7355 22.4852 79.1364C20.1992 83.3041 21.98 85.0641 19.5646 88.2039C17.8549 90.4215 16.9937 89.9357 15.964 92.6813C14.481 96.6377 16.5274 97.1305 15.0639 102.115C13.95 105.909 12.2275 104.959 11.7806 108.085C11.2949 111.478 12.9333 113.407 12.3699 116.793C11.8972 119.644 10.2264 122.228 9.07374 124.685C6.93672 129.233 7.53897 149.994 28.3393 149.754C41.9709 149.599 47.5142 139.835 50.4801 128.916C51.976 123.418 47.9286 119.504 50.7586 111.95C52.4293 107.5 55.2204 105.156 54.2944 101.861C53.582 99.334 51.6328 99.6508 50.0398 96.0605C49.2886 94.3709 47.3393 92.0829 47.6761 88.7671L47.6826 88.76Z'
          fill='#42152A'
        />
        <path
          d='M40.2039 91.8576L40.0939 92.4138C41.402 92.7095 42.2438 94.1104 41.9718 95.5254C41.6999 96.9405 40.4112 97.8486 39.1031 97.553C38.4684 97.4051 37.9245 97.0038 37.5748 96.4195C37.2186 95.8352 37.0956 95.1312 37.2315 94.4483C37.3093 94.0471 37.4776 93.6739 37.7108 93.3571C37.5683 93.2445 37.4388 93.1178 37.3222 92.977C37.0308 93.3712 36.8171 93.8288 36.72 94.3287C36.5581 95.1664 36.707 96.0182 37.1409 96.7293C37.5748 97.4473 38.2353 97.9331 39.0059 98.1091C39.8089 98.2921 40.6119 98.1021 41.2466 97.6374C41.8682 97.1869 42.328 96.4899 42.4964 95.6381C42.8267 93.9133 41.8035 92.2167 40.2169 91.8506L40.2039 91.8576Z'
          fill='white'
        />
        <path
          d='M13.1018 202.673C10.8806 206.172 7.5391 212.945 6.87857 214.31C6.35403 215.387 12.6744 220.414 12.9853 219.992C14.6949 217.633 19.3445 211.149 20.5814 209.474C22.6731 206.637 25.1015 203.166 27.4522 199.576L17.8939 193.12C16.1455 196.943 14.2675 200.85 13.1083 202.68L13.1018 202.673Z'
          fill='#FAB582'
        />
        <path
          d='M14.2284 218.33L21.1964 233.192C21.9411 234.783 20.2315 236.388 18.891 235.36L1.04367 221.773C-0.270919 220.689 8.01813 212.058 8.01813 212.058L8.15412 213.444C8.47791 216.69 11.2755 218.943 14.2284 218.33Z'
          fill='#00468A'
        />
        <path
          d='M1.12975 219.41L0.141224 220.952C-0.0877875 221.309 -0.0070198 221.8 0.321626 222.049L19.8526 236.845C20.1812 237.094 20.6333 237.006 20.8623 236.649L21.8508 235.106C22.0798 234.749 21.9991 234.258 21.6704 234.009L2.13947 219.213C1.81082 218.964 1.35876 219.052 1.12975 219.41Z'
          fill='#42152A'
        />
        <path
          d='M12.8288 221.878C12.5569 221.878 12.2978 221.695 12.1942 221.399C12.0647 221.019 12.246 220.597 12.5957 220.456L14.9788 219.499C15.3285 219.358 15.7171 219.555 15.8466 219.935C15.9761 220.315 15.7948 220.738 15.4451 220.878L13.062 221.836C12.9843 221.864 12.9065 221.878 12.8288 221.878Z'
          fill='#42152A'
        />
        <path
          d='M13.9226 224.427C13.6506 224.427 13.3916 224.244 13.288 223.948C13.1584 223.568 13.3398 223.146 13.6895 223.005L16.0726 222.047C16.4223 221.907 16.8108 222.104 16.9403 222.484C17.0698 222.864 16.8885 223.286 16.5388 223.427L14.1557 224.385C14.078 224.413 14.0003 224.427 13.9226 224.427Z'
          fill='#42152A'
        />
        <path
          d='M15.1492 227.109C14.8772 227.109 14.6181 226.926 14.5145 226.63C14.385 226.25 14.5663 225.828 14.916 225.687L17.2991 224.73C17.6488 224.589 18.0374 224.786 18.1669 225.166C18.2964 225.546 18.1151 225.969 17.7654 226.109L15.3823 227.067C15.3046 227.095 15.2269 227.109 15.1492 227.109Z'
          fill='#42152A'
        />
        <path
          d='M46.0691 138.103L28.8304 132.175C28.8304 132.175 21.2473 146.84 23.6563 160.462C24.673 166.213 24.1096 173.514 22.8597 178.688C19.8744 191.072 12.602 202.124 8.0625 206.566L18.508 215.395C22.1085 209.889 39.8523 188.129 41.0568 183.687C44.5796 170.74 46.0691 138.096 46.0691 138.096V138.103Z'
          fill='#1B224C'
        />
        <path
          d='M50.7536 211.776C50.7407 216.021 51.602 223.829 51.7639 225.356C51.8934 226.567 59.6255 226.666 59.6579 226.131C59.8392 223.132 60.3055 214.93 60.4544 212.783C60.707 209.157 60.9013 204.8 60.9725 200.393L49.7305 200.942C50.2744 205.173 50.7601 209.545 50.7536 211.769V211.776Z'
          fill='#FAB582'
        />
        <path
          d='M59.8221 223.991L73.2983 231.967C74.7359 232.819 74.1595 235.198 72.5212 235.17L50.7365 234.931C49.0852 234.846 51.4359 222.632 51.4359 222.632L52.2713 223.688C54.227 226.166 57.7045 226.3 59.8221 223.991Z'
          fill='#00468A'
        />
        <path
          d='M49.5774 232.935L49.5642 234.815C49.5611 235.251 49.8833 235.606 50.2839 235.61L74.0882 235.808C74.4888 235.812 74.816 235.461 74.8191 235.026L74.8324 233.146C74.8355 232.711 74.5132 232.355 74.1127 232.352L50.3083 232.153C49.9077 232.15 49.5805 232.5 49.5774 232.935Z'
          fill='#42152A'
        />
        <path
          d='M60.1267 227.905C59.9907 227.905 59.8547 227.863 59.7381 227.771C59.4337 227.539 59.3625 227.074 59.5762 226.743L61.0462 224.49C61.2599 224.16 61.6809 224.082 61.9917 224.314C62.2961 224.547 62.3673 225.011 62.1536 225.342L60.6836 227.595C60.5541 227.799 60.3404 227.905 60.1331 227.905H60.1267Z'
          fill='#42152A'
        />
        <path
          d='M62.361 229.334C62.225 229.334 62.089 229.292 61.9725 229.2C61.6681 228.968 61.5969 228.503 61.8106 228.172L63.2806 225.92C63.4943 225.589 63.9217 225.511 64.2261 225.744C64.5304 225.976 64.6017 226.441 64.388 226.772L62.918 229.024C62.7884 229.228 62.5747 229.334 62.3675 229.334H62.361Z'
          fill='#42152A'
        />
        <path
          d='M64.7634 230.798C64.6274 230.798 64.4914 230.756 64.3748 230.665C64.0705 230.432 63.9992 229.968 64.2129 229.637L65.6829 227.384C65.8966 227.053 66.324 226.976 66.6284 227.208C66.9328 227.44 67.004 227.905 66.7903 228.236L65.3203 230.489C65.1908 230.693 64.9771 230.798 64.7698 230.798H64.7634Z'
          fill='#42152A'
        />
        <path
          d='M50.7669 137.068L31.3589 133.175C31.3589 133.175 29.3514 154.583 39.4019 163.137C46.2079 168.931 48.7141 195.288 49.7308 218.682L60.8627 217.725C60.9663 210.966 62.8832 180.335 61.5751 175.928C57.7478 163.081 50.7669 137.068 50.7669 137.068Z'
          fill='#1B224C'
        />
        <path
          d='M52.0543 141.862C51.2578 138.92 50.7591 137.068 50.7591 137.068L32.3031 133.365L28.8255 132.168C28.8255 132.168 26.3583 136.942 24.6875 143.573C25.9438 143.848 27.3102 144.101 28.7867 144.298C37.6003 145.495 43.9272 144.031 48.0846 143.024C49.7165 142.63 51.0117 142.236 52.0608 141.862H52.0543Z'
          fill='#FAB582'
        />
        <path
          d='M84.1856 80.3263L78.2279 76.6162L61.4167 95.0891L58.25 95.7438L61.3584 108.085L67.1219 107.05L84.1856 80.3263Z'
          fill='#FAB582'
        />
        <path
          d='M111.177 100.678L79.7109 74.9756V117.229H142.636V74.9756L111.177 100.678Z'
          fill='#F5F5F5'
        />
        <path
          d='M142.636 74.9756H79.7109L111.177 100.678L142.636 74.9756Z'
          fill='#C4C4C4'
        />
        <path
          d='M39.0898 99.7846L42.7811 111.422L61.3602 108.085L58.2518 95.7437L39.0898 99.7846Z'
          fill='#00468A'
        />
        <path
          d='M41.796 99.2637L30.1007 101.326C29.0128 101.517 27.9507 101.861 26.9664 102.397C21.6627 105.276 23.5018 112.421 24.3372 116.131L27.4391 133.175L25.1467 139.807C25.1467 139.807 33.6041 141.588 42.5861 140.961C46.763 140.673 48.9065 139.504 52.5653 137.068L50.4671 124.425C55.3888 113.942 49.2626 104.445 46.0312 100.665C45.4225 99.9466 44.7814 99.5383 44.082 99.2989C43.3373 99.0455 42.5407 99.0525 41.7896 99.2637H41.796Z'
          fill='#00468A'
        />
        <path
          d='M31.3633 89.5835L31.1172 101.136C31.2273 102.382 33.9277 105.951 37.2627 105.916C39.0954 105.895 40.6237 104.494 40.3064 102.537L38.9011 93.7371L31.3633 89.5835Z'
          fill='#FAB582'
        />
        <path
          d='M39.9834 100.509L39.3423 96.5459L32.7305 93.4624L33.0025 95.0534C33.0025 95.0534 33.9803 97.6793 39.9834 100.516V100.509Z'
          fill='#E69361'
        />
        <path
          d='M33.3133 99.2071L43.3638 95.2858C44.7949 94.7367 45.7857 93.4413 46.103 91.9418C46.3491 90.7732 46.0707 89.5412 45.4878 88.5204L41.3174 79.7698L28.832 79.0376L33.3198 99.2071H33.3133Z'
          fill='#FAB582'
        />
        <path
          d='M41.3173 79.7697C41.7771 80.2484 32.7303 80.713 32.7303 93.4553L31.2603 94.2861C31.2603 94.2861 22.6669 91.6742 25.866 82.0436C27.7051 76.5102 36.6482 74.891 41.3108 79.7626L41.3173 79.7697Z'
          fill='#42152A'
        />
        <path
          d='M31.4413 95.0538C32.6912 95.9197 34.349 95.5255 35.152 94.1668C35.9485 92.8081 35.5859 91.0058 34.336 90.1329C33.0862 89.267 31.4284 89.6612 30.6254 91.0199C29.8289 92.3786 30.1915 94.1808 31.4413 95.0538Z'
          fill='#FAB582'
        />
        <path
          d='M33.2087 93.8358L32.8331 94.237C33.7721 95.2719 33.7592 96.9404 32.8072 97.9541C31.8553 98.9679 30.3205 98.9538 29.388 97.9189C28.9347 97.4191 28.6886 96.7573 28.6886 96.0533C28.6886 95.3494 28.9476 94.6946 29.4074 94.2018C29.6794 93.9132 30.0032 93.709 30.3594 93.5823C30.3011 93.4063 30.2558 93.2162 30.2298 93.0332C29.783 93.181 29.375 93.4415 29.0383 93.8006C28.4814 94.399 28.1641 95.2015 28.1641 96.0533C28.1641 96.9052 28.4619 97.7148 29.0124 98.3273C29.5887 98.9679 30.3529 99.2847 31.117 99.2847C31.8618 99.2847 32.6065 98.982 33.1763 98.3695C34.329 97.1375 34.3485 95.103 33.2087 93.8428V93.8358Z'
          fill='white'
        />
        <path
          d='M33.6426 92.899L32.0625 92.0894L32.1467 91.9204L33.7268 92.73L33.6426 92.899Z'
          fill='#42152A'
        />
        <path
          d='M32.5681 93.2441L32.4062 93.1597L33.2222 91.5757L33.3906 91.6602L32.5681 93.2441Z'
          fill='#42152A'
        />
        <path
          d='M41.3693 84.8878C41.4406 85.1131 41.6737 85.2328 41.8809 85.1553C42.0881 85.0779 42.1982 84.8245 42.127 84.5992C42.0558 84.3739 41.8226 84.2542 41.6154 84.3317C41.4082 84.4091 41.2981 84.6625 41.3693 84.8878Z'
          fill='#42152A'
        />
        <path
          d='M42.5807 82.5649L44.8019 84.3531C45.0868 84.5854 45.1775 85.0148 45.0027 85.3528L44.4393 86.4721L42.5742 82.5649H42.5807Z'
          fill='#FAB582'
        />
        <path
          d='M83.2323 74.1167L84.1972 76.6581C84.2879 76.8482 84.3268 77.0594 84.3138 77.2706C84.2749 77.9042 84.126 79.1995 83.6209 78.8898C82.9603 78.4815 81.6328 75.4895 81.6328 75.4895'
          fill='#FAB582'
        />
        <path
          d='M84.2987 72.7793L85.2636 75.3207C85.3543 75.5108 85.3932 75.722 85.3802 75.9332C85.3414 76.5668 85.1924 77.8621 84.6873 77.5524C84.0268 77.1441 82.6992 74.1521 82.6992 74.1521'
          fill='#FAB582'
        />
        <path
          d='M85.3612 71.4487L86.3261 73.9902C86.4168 74.1802 86.4557 74.3914 86.4427 74.6026C86.4039 75.2362 86.2549 76.5316 85.7498 76.2218C85.0893 75.8135 83.7617 72.8215 83.7617 72.8215'
          fill='#FAB582'
        />
        <path
          d='M85.1214 71.8218C85.1214 71.8218 86.164 74.4829 86.818 74.8912C87.3166 75.201 87.4656 73.9056 87.5109 73.272C87.5239 73.0608 87.485 72.8496 87.3944 72.6596L86.8504 71.2375C86.5914 70.5617 85.9114 70.1885 85.2638 70.3927C84.1759 70.7376 82.5634 71.4698 81.469 73.0045C79.6881 75.5107 78.1016 76.7357 78.1016 76.7357L79.3061 77.5734C80.5559 78.4394 82.2202 77.9536 82.8937 76.5245L85.1149 71.8288L85.1214 71.8218Z'
          fill='#FAB582'
        />
        <path
          d='M44.8467 174.816C45.1834 172.521 44.5682 157.984 44.3286 159.033C43.7069 161.757 44.0631 167.572 43.4414 170.191C44.0178 172.078 44.3286 172.648 44.8467 174.809V174.816Z'
          fill='#2E3A7F'
        />
        <path
          d='M40.5977 88.1195C40.5977 88.1195 42.1842 88.5067 44.5609 87.5845C44.5609 87.5845 43.0455 91.9211 40.5977 88.1195Z'
          fill='white'
        />
        <path
          d='M73.7565 117.744L70.4085 112.182L49.5693 119.497L45.6449 114.196L35.4844 122.052L45.891 133.936L73.7565 117.744Z'
          fill='#FAB582'
        />
        <path
          d='M77.3828 115.258L81.8965 112.238C82.0324 112.147 82.1879 112.097 82.3433 112.097C82.816 112.09 83.7939 112.126 83.5996 112.59C83.3406 113.196 78.5226 116.561 78.5226 116.561'
          fill='#FAB582'
        />
        <path
          d='M72.3945 111.302L74.0523 111.387C74.3438 111.401 74.6416 111.358 74.9201 111.26L79.3431 109.387C79.3431 109.387 80.7742 109.31 80.6253 110.028C80.4763 110.746 76.1829 113.667 76.1829 113.667L81.3959 110.183C81.506 110.112 81.629 110.07 81.7586 110.063C82.2572 110.049 83.507 110.063 83.2739 110.626C82.9825 111.316 77.478 115.16 77.478 115.16'
          fill='#FAB582'
        />
        <path
          d='M82.931 113.984C82.672 113.914 82.2575 113.97 81.7977 114.111L78.9095 116.35L76.2026 113.33L72.3948 111.302L69.8239 112.76C69.8239 112.76 69.008 117.244 74.8621 118.912C75.2636 119.025 75.691 119.011 76.0925 118.877L79.4858 117.702C79.5506 117.666 79.6089 117.624 79.6672 117.582C80.2176 117.103 83.2872 114.843 83.4037 114.569C83.4685 114.414 83.1641 114.062 82.931 113.992V113.984Z'
          fill='#FAB582'
        />
        <path
          d='M74.093 111.767L73.0115 111.041C72.5323 110.689 72.7266 110.126 72.759 109.5L73.1087 107.564C73.154 107.317 72.9533 107.092 72.7266 107.148C72.2927 107.254 71.412 107.451 71.0558 108.648L69.5664 113.069L74.093 111.767Z'
          fill='#FAB582'
        />
        <path
          d='M45.4375 113.888L35.2812 121.746L35.6868 122.365L45.8431 114.507L45.4375 113.888Z'
          fill='#1B224C'
        />
        <path
          d='M58.5847 95.6492L57.9102 95.8501L61.0207 108.194L61.6952 107.993L58.5847 95.6492Z'
          fill='#1B224C'
        />
        <path
          d='M40.1961 104.896C40.902 103.685 40.9862 101.861 40.4681 99.5029L39.7752 99.6226C40.3775 102.312 40.0278 103.748 39.6198 104.466C39.1794 105.233 38.6031 105.381 38.5642 105.388C33.8498 106.712 31.5898 102.347 31.0717 101.157L30.3594 101.284C30.6896 102.08 32.6842 106.395 36.8676 106.395C37.4439 106.395 38.0591 106.311 38.7197 106.128C38.752 106.12 39.5939 105.93 40.1961 104.896Z'
          fill='#1B224C'
        />
        <path
          d='M34.5449 77.6441C32.5827 78.5522 30.9379 79.7279 29.9341 81.4386C29.4484 82.2975 29.0404 83.2268 28.7944 84.2616C28.7037 84.5151 28.6778 84.7826 28.626 85.0501L28.4641 85.8597C28.3799 86.4088 28.3281 86.965 28.1986 87.5493C28.0173 87.0002 27.8877 86.4299 27.7777 85.8527C27.7453 85.2683 27.6546 84.6699 27.7258 84.0716C27.7841 82.8677 28.1532 81.6568 28.7749 80.6009C29.3966 79.5378 30.3356 78.7282 31.3458 78.2143C32.3561 77.7074 33.4828 77.4822 34.5514 77.6441H34.5449Z'
          fill='#F3223C'
        />
        <path
          d='M22.5379 211.77L10.7266 202.045L6.72676 207.786L18.5381 217.511L22.5379 211.77Z'
          fill='#2E3A7F'
        />
        <path
          d='M62.2159 212.033L47.7461 213.329L48.2901 220.507L62.7598 219.211L62.2159 212.033Z'
          fill='#2E3A7F'
        />
        <path
          d='M254.795 196.914C257.56 200.66 262.618 208.706 263.466 210.178C264.14 211.346 256.602 216.866 256.226 216.415C254.122 213.909 248.404 207.017 246.882 205.236C244.311 202.223 241.313 198.527 238.398 194.69L248.689 186.573C250.949 190.726 253.358 194.957 254.802 196.914H254.795Z'
          fill='#FAB582'
        />
        <path
          d='M254.692 214.655L247.957 232.016C247.238 233.867 249.285 235.529 250.716 234.255L269.807 217.373C271.212 216.035 261.22 207.038 261.22 207.038L261.168 208.608C261.045 212.29 258.059 215.078 254.692 214.655Z'
          fill='#1B224C'
        />
        <path
          d='M247.296 234.173L248.641 235.979C248.893 236.317 249.35 236.369 249.661 236.095L270.705 217.563C271.016 217.289 271.064 216.793 270.812 216.454L269.467 214.649C269.215 214.311 268.758 214.258 268.447 214.533L247.403 233.064C247.092 233.339 247.044 233.835 247.296 234.173Z'
          fill='#2E3A7F'
        />
        <path
          d='M256.537 218.527C256.848 218.506 257.126 218.274 257.217 217.929C257.334 217.485 257.101 217.028 256.693 216.901L253.94 216.035C253.539 215.908 253.111 216.162 252.995 216.605C252.878 217.049 253.111 217.506 253.519 217.633L256.272 218.499C256.362 218.527 256.453 218.534 256.537 218.527Z'
          fill='#2E3A7F'
        />
        <path
          d='M255.49 221.491C255.801 221.47 256.08 221.238 256.17 220.893C256.287 220.449 256.054 219.992 255.646 219.865L252.893 218.999C252.485 218.872 252.065 219.126 251.948 219.569C251.831 220.013 252.065 220.47 252.473 220.597L255.225 221.463C255.315 221.491 255.406 221.498 255.49 221.491Z'
          fill='#2E3A7F'
        />
        <path
          d='M254.314 224.624C254.625 224.603 254.904 224.37 254.994 224.025C255.111 223.582 254.878 223.124 254.47 222.998L251.718 222.132C251.31 222.005 250.889 222.258 250.772 222.702C250.656 223.145 250.889 223.603 251.297 223.73L254.049 224.596C254.14 224.624 254.23 224.631 254.314 224.624Z'
          fill='#2E3A7F'
        />
        <path
          d='M216.145 147.037L233.144 130.528C233.144 130.528 244.308 146.333 241.355 159.835C239.354 168.973 248.329 183.771 255.161 189.558L236.951 204.011C232.995 198.801 230.022 192.332 228.526 188.002C224.155 175.365 216.151 147.044 216.151 147.044L216.145 147.037Z'
          fill='#00468A'
        />
        <path
          d='M215.934 207.601C215.947 212.501 215.28 222.427 215.093 224.194C214.944 225.588 205.696 224.786 205.657 224.159C205.444 220.703 204.913 211.241 204.744 208.763C204.453 204.581 204.226 199.555 204.148 194.472L217.113 195.112C216.485 199.991 215.928 205.039 215.934 207.601Z'
          fill='#FAB582'
        />
        <path
          d='M205.465 221.695L189.923 230.897C188.265 231.882 188.926 234.621 190.817 234.593L215.943 234.318C217.847 234.219 215.14 220.125 215.14 220.125L214.175 221.343C211.921 224.202 207.906 224.357 205.465 221.688V221.695Z'
          fill='#1B224C'
        />
        <path
          d='M188.169 232.177L188.186 234.584C188.189 235.02 188.516 235.37 188.917 235.367L216.6 235.135C217.001 235.132 217.323 234.776 217.32 234.341L217.303 231.933C217.3 231.498 216.972 231.148 216.572 231.151L188.889 231.382C188.488 231.385 188.166 231.741 188.169 232.177Z'
          fill='#2E3A7F'
        />
        <path
          d='M205.114 226.215C205.27 226.215 205.425 226.166 205.568 226.06C205.917 225.793 206.002 225.258 205.755 224.878L204.065 222.28C203.819 221.9 203.327 221.808 202.977 222.076C202.628 222.343 202.543 222.878 202.789 223.258L204.48 225.856C204.629 226.088 204.875 226.215 205.114 226.215Z'
          fill='#2E3A7F'
        />
        <path
          d='M202.544 227.862C202.699 227.862 202.855 227.813 202.997 227.707C203.347 227.44 203.431 226.905 203.185 226.525L201.495 223.927C201.249 223.547 200.757 223.455 200.407 223.723C200.057 223.99 199.973 224.525 200.219 224.905L201.909 227.503C202.058 227.735 202.304 227.862 202.544 227.862Z'
          fill='#2E3A7F'
        />
        <path
          d='M199.773 229.552C199.929 229.552 200.084 229.503 200.226 229.397C200.576 229.13 200.66 228.595 200.414 228.215L198.718 225.617C198.471 225.237 197.979 225.145 197.63 225.413C197.28 225.68 197.196 226.215 197.442 226.595L199.139 229.193C199.287 229.425 199.534 229.552 199.773 229.552Z'
          fill='#2E3A7F'
        />
        <path
          d='M211.001 141.32L233.097 137.427C233.097 137.427 238.828 159.11 228.777 167.663C221.971 173.457 218.817 195.823 220.844 204.975L198.315 203.933C198.211 197.175 201.482 181.75 202.79 177.35C206.617 164.502 211.001 141.313 211.001 141.313V141.32Z'
          fill='#00468A'
        />
        <path
          d='M222.665 179.899C222.328 177.604 222.192 165.369 222.425 166.418C223.047 169.142 223.681 172.219 224.303 174.844C223.727 176.731 223.053 177.984 222.658 179.899H222.665Z'
          fill='#1088F3'
        />
        <path
          d='M213.042 92.5965L231.213 93.0541C239.101 93.8778 241.613 98.9254 241.568 103.614L241.238 125.896L244.722 149.043L206.89 151.408L205.906 111.435C204.896 105.839 206.191 100.214 208.794 95.2647C209.26 94.3706 209.817 93.7722 210.471 93.3287C211.235 92.8077 212.136 92.5754 213.036 92.5965H213.042Z'
          fill='#1B224C'
        />
        <path
          d='M223.986 82.3604L225.197 92.6457C225.366 94.0185 222.879 98.0454 219.693 99.4815C217.821 100.319 215.749 98.8761 215.633 96.6796L215.102 86.8237L223.986 82.3674V82.3604Z'
          fill='#FAB582'
        />
        <path
          d='M215.327 91.0687L215.094 86.6265L221.492 81.4873L221.57 83.2755C221.57 83.2755 221.123 86.373 215.327 91.0687Z'
          fill='#E69361'
        />
        <path
          d='M224.361 85.5423L213.106 88.316C211.474 88.7314 209.836 88.1752 208.722 86.9855C207.848 86.0562 207.433 84.7257 207.414 83.4021L208.016 71.9129L222.736 68.1606L224.368 85.5423H224.361Z'
          fill='#FAB582'
        />
        <path
          d='M207.59 79.9665C207.59 79.9665 213.612 78.9387 216.287 79.9665C218.903 80.9732 219.285 77.7278 219.065 75.8974C218.728 73.0814 223.689 85.0846 220.153 86.5841C216.617 88.0836 207.473 90.7306 207.324 84.9367C207.246 81.8391 207.583 79.9735 207.583 79.9735L207.59 79.9665Z'
          fill='#1B224C'
        />
        <path
          d='M206.081 69.2449C207.441 77.2282 218.566 70.0122 218.78 73.497C219.33 82.4025 223.876 80.368 223.876 80.368C223.876 80.368 229.711 67.0554 222.452 66.8794C215.192 66.7034 204.067 57.4459 206.074 69.2449H206.081Z'
          fill='#1B224C'
        />
        <path
          d='M226.032 77.2776C226.421 79.0657 225.398 80.8539 223.753 81.2763C222.108 81.6987 220.463 80.5864 220.075 78.7982C219.686 77.0101 220.709 75.2219 222.354 74.7995C223.999 74.3771 225.644 75.4894 226.032 77.2776Z'
          fill='#FAB582'
        />
        <path
          d='M208.432 74.2856L206.1 78.6856C205.751 79.3403 206.262 80.0232 207.052 79.9598L208.665 79.7416L208.432 74.2856Z'
          fill='#FAB582'
        />
        <path
          d='M222.581 79.0796L222.406 78.967L223.533 76.9888L223.708 77.1084L222.581 79.0796Z'
          fill='#1B224C'
        />
        <path
          d='M223.907 78.7417L222.094 77.5167L222.197 77.3267L224.017 78.5516L223.907 78.7417Z'
          fill='#1B224C'
        />
        <path
          d='M210.776 76.7073C210.835 76.9677 210.686 77.2282 210.446 77.2845C210.206 77.3479 209.967 77.186 209.915 76.9255C209.857 76.665 210.006 76.4045 210.245 76.3482C210.485 76.2849 210.724 76.4468 210.776 76.7073Z'
          fill='#1B224C'
        />
        <path
          d='M224.897 137.617L190.336 109.38V155.801H259.459V109.38L224.897 137.617Z'
          fill='#F5F5F5'
        />
        <path
          d='M259.459 109.38H190.336L224.897 137.617L259.459 109.38Z'
          fill='#C4C4C4'
        />
        <path
          d='M230.65 100.376L232.237 98.8269C234.581 96.5319 236.303 94.7156 238.415 97.2641L259.189 122.369L258.082 145.481C258.496 148.86 260.141 154.224 259.059 155.844C258.36 156.9 258.114 156.111 257.11 156.519C256.107 156.928 256.372 156.829 255.258 156.787C254.144 156.745 253.38 157.681 252.674 157.04C251.968 156.4 251.839 156.442 250.667 156.118C249.521 155.801 250.447 152.837 250.589 150.599L249.262 152.584C248.588 153.232 248.18 152.837 248.083 152.317C248.038 152.077 247.966 151.655 248.07 151.063C248.381 149.282 249.236 147.67 250.453 146.431L251.347 145.523L249.268 127.191L229.595 106.029C227.483 103.48 228.306 102.664 230.65 100.376Z'
          fill='#FAB582'
        />
        <path
          d='M230.469 95.5042L228.914 97.0811C226.616 99.4043 226.486 103.311 228.623 105.811L240.461 119.905L250.466 110.07L245.939 104.515L238.499 95.821C236.362 93.3218 232.768 93.181 230.469 95.5042Z'
          fill='#1B224C'
        />
        <path
          d='M210.932 81.5156C211.327 81.241 211.735 80.8046 212.084 80.1146C212.11 80.0654 212.091 80.009 212.045 79.9809C212 79.9527 211.948 79.9738 211.922 80.0231C210.796 82.2407 209.144 81.7127 209.073 81.6916C209.028 81.6775 208.976 81.7057 208.956 81.7549C208.944 81.8042 208.969 81.8605 209.015 81.8817C209.028 81.8817 209.96 82.1914 210.932 81.5226V81.5156Z'
          fill='#FAB582'
        />
        <path
          d='M225.054 64.7254C225.054 65.1408 224.743 65.4787 224.361 65.4787C223.979 65.4787 223.668 65.1408 223.668 64.7254C223.668 64.3101 223.979 63.9722 224.361 63.9722C224.743 63.9722 225.054 64.3101 225.054 64.7254Z'
          fill='#FA596D'
        />
        <path
          d='M211.398 63.7257L225.516 75.4683C225.516 75.4683 230.968 58.6217 211.398 63.7257Z'
          fill='#FA596D'
        />
        <path
          d='M216.209 67.7313C216.209 67.7313 206.21 60.811 210.374 60.9518C215.93 61.1349 216.209 67.7313 216.209 67.7313Z'
          fill='#FA596D'
        />
        <path
          d='M235.348 0.508789C235.378 0.500093 235.471 0.492098 235.653 0.541992C236.018 0.641828 236.532 0.920631 237.115 1.35645C238.274 2.2222 239.538 3.57645 240.208 4.84473C240.384 5.17742 240.517 5.41291 240.613 5.54688C240.638 5.58161 240.671 5.62496 240.711 5.66504C240.731 5.68524 240.762 5.71387 240.802 5.74121C240.838 5.7659 240.911 5.80988 241.014 5.82715C241.133 5.84717 241.277 5.82729 241.403 5.73438C241.514 5.65279 241.562 5.54941 241.583 5.49316C241.621 5.38966 241.618 5.29479 241.617 5.26367C241.613 5.1228 241.564 4.91152 241.521 4.73242C241.479 4.55963 241.4 4.25033 241.345 4.02246C241.215 3.48823 241.096 2.93116 241.082 2.53711C241.081 2.50014 241.082 2.46738 241.082 2.43848C241.282 2.53339 241.544 2.71352 241.845 2.99707C242.244 3.37313 242.669 3.89074 243.049 4.51074C243.765 5.6788 244.296 7.15991 244.253 8.67188C244.086 8.74517 243.849 8.84669 243.565 8.96191C242.982 9.19893 242.204 9.49254 241.417 9.72461C240.62 9.95969 239.855 10.1195 239.282 10.1143C238.995 10.1116 238.802 10.0674 238.686 10.0078C238.59 9.9589 238.548 9.90332 238.527 9.81445C238.451 9.48229 238.54 9.3274 238.649 9.2207C238.796 9.07767 239.042 8.96969 239.346 8.88574C239.491 8.84551 239.631 8.81577 239.765 8.78613C239.876 8.76147 240.033 8.72732 240.148 8.67871C240.186 8.66301 240.35 8.59665 240.449 8.42676C240.513 8.31727 240.54 8.17992 240.509 8.04004C240.481 7.91664 240.417 7.83158 240.373 7.78418C240.292 7.69598 240.192 7.64087 240.132 7.61035C240.06 7.57375 239.975 7.53839 239.883 7.50293C239.449 7.33665 238.806 7.29613 238.177 7.2832C237.849 7.27647 237.5 7.27744 237.153 7.27832C236.804 7.2792 236.455 7.28047 236.118 7.27441C235.432 7.26209 234.845 7.2201 234.439 7.11035C234.236 7.05539 234.124 6.99552 234.071 6.9502C234.036 6.92022 234.039 6.91093 234.039 6.89453C234.04 6.74288 234.097 6.65381 234.241 6.56543C234.416 6.45857 234.679 6.38668 235.001 6.33105C235.157 6.30407 235.309 6.28281 235.462 6.26074C235.607 6.23988 235.763 6.21631 235.896 6.18359C235.964 6.167 236.04 6.14489 236.113 6.11328C236.183 6.08337 236.281 6.03204 236.366 5.94238C236.462 5.8416 236.536 5.69618 236.535 5.51953C236.534 5.36025 236.471 5.23422 236.417 5.15234L236.415 5.14844L236.351 5.06641C236.283 4.99156 236.207 4.93799 236.144 4.89941C236.055 4.84585 235.958 4.80268 235.865 4.76758C235.68 4.69789 235.455 4.63803 235.221 4.58105C234.734 4.4624 234.171 4.3469 233.577 4.16992C232.367 3.80941 231.301 3.26582 230.924 2.27246C230.821 2.00085 230.809 1.8423 230.819 1.76562C230.826 1.71486 230.836 1.71733 230.842 1.71387C230.873 1.6953 230.963 1.6614 231.157 1.66504C231.345 1.66857 231.588 1.70632 231.881 1.78418C233.067 2.09912 234.788 2.98517 236.333 4.07617C236.724 4.3522 236.995 4.53884 237.164 4.64355C237.232 4.68594 237.335 4.7474 237.43 4.77832C237.456 4.78679 237.517 4.80486 237.596 4.80566C237.666 4.80635 237.872 4.79119 238.014 4.59668C238.145 4.4154 238.109 4.22805 238.097 4.17578C238.08 4.10841 238.054 4.05801 238.041 4.03516C237.996 3.9536 237.924 3.872 237.881 3.82422C237.826 3.76228 237.755 3.68807 237.678 3.60742C237.515 3.4384 237.326 3.24521 237.101 3.00879C236.657 2.54326 236.15 1.98625 235.787 1.4707C235.605 1.21209 235.473 0.983407 235.4 0.796875C235.365 0.70477 235.348 0.634264 235.343 0.584961C235.338 0.537543 235.344 0.521112 235.343 0.523438L235.344 0.522461C235.346 0.516788 235.346 0.511846 235.348 0.508789Z'
          fill='#00468A'
          stroke='#1088F3'
        />
        <path
          d='M238.035 5.03369C239.466 5.54761 241.403 6.4276 243.442 7.95527C245.56 9.53222 247.043 11.2429 248.008 12.5453'
          stroke='#1088F3'
          stroke-miterlimit='10'
          stroke-linecap='round'
        />
        <path
          d='M77.1445 190.199C77.1445 190.199 77.7274 180.807 80.0522 181.392C82.3835 181.969 79.8061 185.968 81.1401 184.581C82.4741 183.201 84.3327 176.738 85.8286 177.583C87.3245 178.428 85.1163 181.617 85.9387 181.469C86.7611 181.321 89.1313 176.07 92.2656 176.337C95.3999 176.605 91.5662 180.653 87.4281 183.257C83.2901 185.862 90.7632 181.603 91.9094 183.011C93.0556 184.419 87.7584 187.481 84.1125 187.692C80.4731 187.904 87.8685 188.235 86.7676 189.706C85.6732 191.177 80.6479 192.571 77.1445 190.206V190.199Z'
          fill='#00468A'
        />
        <path
          d='M85.1733 184.208C83.8069 185.679 81.767 187.559 78.9954 189.206C76.1201 190.91 73.4715 191.754 71.5547 192.198'
          stroke='#FFD333'
          stroke-miterlimit='10'
          stroke-linecap='round'
        />
        <path
          d='M112.348 200.991C112.348 200.991 119.775 196.162 120.663 198.569C121.55 200.977 117.062 200.956 118.869 201.357C120.676 201.758 126.614 199.738 126.834 201.561C127.054 203.377 123.376 203.223 123.959 203.877C124.542 204.532 129.858 203.652 131.445 206.602C133.031 209.551 127.786 208.439 123.46 206.222C119.134 204.004 126.614 208.263 126.199 210.087C125.785 211.91 120.449 208.925 118.221 205.785C115.987 202.652 119.95 209.446 118.208 209.305C116.466 209.164 112.555 205.468 112.348 200.991Z'
          fill='#00468A'
        />
        <path
          d='M121.452 204.75C119.561 204.363 116.978 203.617 114.154 202.075C111.227 200.477 109.083 198.59 107.652 197.126'
          stroke='#FFD333'
          stroke-miterlimit='10'
          stroke-linecap='round'
        />
        <path
          d='M35.0391 198.59C35.8939 198.809 36.7357 199.013 37.5646 199.203'
          stroke='#00468A'
          stroke-width='0.5'
          stroke-miterlimit='10'
        />
        <path
          d='M42.6094 200.181C56.5 202.469 67.4118 200.709 73.9005 199.125C83.828 196.696 95.5427 193.838 101.798 182.877C105.852 175.767 108.889 163.017 103.042 157.695C98.5604 153.612 89.695 154.661 86.1074 159.589C81.1729 166.361 86.8845 179.519 92.8293 185.855C102.219 195.852 119.438 196.534 137.415 188.868'
          stroke='#00468A'
          stroke-width='0.5'
          stroke-miterlimit='10'
          stroke-dasharray='7.9 7.9'
        />
        <path
          d='M139.777 187.819C140.567 187.453 141.351 187.073 142.141 186.671'
          stroke='#00468A'
          stroke-width='0.5'
          stroke-miterlimit='10'
        />
        <path
          d='M135.633 39.4028C135.633 39.4028 141.804 45.2742 140.684 46.1049C139.564 46.9426 138.663 44.8447 138.663 44.8447C138.663 44.8447 140.574 47.8226 138.974 47.5199C137.375 47.2101 135.633 39.4028 135.633 39.4028Z'
          fill='#FA596D'
        />
        <path
          d='M130.728 46.7595L129.873 46.7173L129.996 42.5003C129.996 42.3947 129.925 42.3103 129.828 42.3032C129.731 42.3173 129.653 42.3807 129.647 42.4863L129.524 46.6891L128.067 47.372C127.976 47.4142 127.937 47.5269 127.976 47.6184C128.002 47.6888 128.067 47.731 128.138 47.731C128.164 47.731 128.183 47.731 128.209 47.7169L129.407 47.1538L129.167 47.9493C129.135 48.0478 129.187 48.1534 129.278 48.1886C129.297 48.1886 129.316 48.1957 129.329 48.1957C129.401 48.1957 129.472 48.1464 129.498 48.0689L129.796 47.0833L130.715 47.1326C130.715 47.1326 130.715 47.1326 130.722 47.1326C130.812 47.1326 130.89 47.0552 130.897 46.9496C130.897 46.844 130.825 46.7525 130.728 46.7525V46.7595Z'
          fill='#42152A'
        />
        <path
          d='M134.841 46.7595L133.987 46.7173L134.11 42.5003C134.11 42.3947 134.038 42.3103 133.941 42.3032C133.844 42.3173 133.766 42.3807 133.76 42.4863L133.637 46.6891L132.18 47.372C132.089 47.4142 132.05 47.5269 132.089 47.6184C132.115 47.6888 132.18 47.731 132.251 47.731C132.277 47.731 132.296 47.731 132.322 47.7169L133.52 47.1538L133.281 47.9493C133.248 48.0478 133.3 48.1534 133.391 48.1886C133.41 48.1886 133.43 48.1957 133.443 48.1957C133.514 48.1957 133.585 48.1464 133.611 48.0689L133.909 47.0833L134.828 47.1326C134.828 47.1326 134.828 47.1326 134.835 47.1326C134.926 47.1326 135.003 47.0552 135.01 46.9496C135.01 46.844 134.939 46.7525 134.841 46.7525V46.7595Z'
          fill='#42152A'
        />
        <path
          d='M133.812 31.8911V31.6095C133.87 29.8355 132.724 28.2092 131.105 27.984C129.246 27.7235 127.627 29.2582 127.569 31.2505L127.336 39.1282H127.355C127.504 42.0146 129.719 44.3237 132.465 44.2674C134.913 44.2111 137.03 42.1413 137.322 39.4943C137.574 37.2345 136.538 35.1929 134.893 34.1369C134.174 33.6793 133.786 32.7922 133.812 31.8911Z'
          fill='#FA596D'
        />
        <path
          d='M130.359 30.4692L130.313 31.9758L128.785 31.1662L130.359 30.4692Z'
          fill='#00468A'
        />
        <path
          d='M129.247 30.286C129.247 30.3916 129.163 30.4761 129.065 30.4761C128.968 30.4761 128.891 30.3845 128.891 30.2789C128.891 30.1733 128.975 30.0889 129.072 30.0889C129.169 30.0889 129.247 30.1804 129.247 30.286Z'
          fill='#42152A'
        />
        <path
          d='M131.731 30.3705C131.731 30.4761 131.647 30.5605 131.55 30.5605C131.453 30.5605 131.375 30.469 131.375 30.3634C131.375 30.2578 131.459 30.1733 131.556 30.1733C131.653 30.1733 131.731 30.2649 131.731 30.3705Z'
          fill='#42152A'
        />
      </g>
      <defs>
        <clipPath id='clip0_5887_587740'>
          <rect width='271' height='237' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NoMail;
